var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106.9 100",
    style: {
      enableBackground: "new 0 0 106.9 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000060021275320161767770000008981659586047385006_);}\r\n\t.st2{fill:url(#SVGID_00000162339657893020847060000014859485850331891848_);}\r\n\t.st3{fill:url(#SVGID_00000102528939520729057290000003655631395998489781_);}\r\n\t.st4{fill:url(#SVGID_00000025404388018904778910000013424781756665166731_);}\r\n\t.st5{fill:url(#SVGID_00000113343518575703259380000011014456511596071589_);}\r\n\t.st6{fill:url(#SVGID_00000115498835450298237730000008234359501936168627_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.5628,
    y1: 28.1261,
    x2: 91.3354,
    y2: 71.8735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.01
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.34,5.31v89.39c0,2.93-2.38,5.31-5.31,5.31H34.87c-2.93,0-5.31-2.38-5.31-5.31V5.31 c0-2.93,2.38-5.31,5.31-5.31h8.85v1.07c0,1.06,0.86,1.93,1.93,1.93h15.61c1.06,0,1.93-0.86,1.93-1.93V0h8.85 C74.96,0,77.34,2.38,77.34,5.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089553039972418548540000017816360955489143695_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.6264,
    y1: 23.1327,
    x2: 151.5123,
    y2: 61.7164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089553039972418548540000017816360955489143695_)"
    },
    d: "M98.8,32.36c-0.93-0.89-2.44-0.89-3.37,0 s-0.93,2.34,0,3.24c8.27,7.95,8.27,20.84,0,28.79c-0.93,0.89-0.93,2.34,0,3.24s2.44,0.89,3.37,0 C108.93,57.9,108.93,42.1,98.8,32.36z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089565961758047542930000015161669232664027831_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.8505,
    y1: 24.173,
    x2: 151.2883,
    y2: 62.7567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089565961758047542930000015161669232664027831_)"
    },
    d: "M93.74,37.22c-0.93-0.89-2.44-0.89-3.37,0 c-0.93,0.89-0.93,2.34,0,3.24c5.48,5.27,5.48,13.81,0,19.08c-0.93,0.89-0.93,2.34,0,3.24c0.93,0.89,2.44,0.89,3.37,0 C101.09,55.72,101.09,44.28,93.74,37.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091712619379387323690000007806040321563560372_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.0746,
    y1: 25.2135,
    x2: 151.0641,
    y2: 63.7972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091712619379387323690000007806040321563560372_)"
    },
    d: "M88.69,42.08c-0.93-0.89-2.44-0.89-3.37,0 c-0.93,0.89-0.93,2.34,0,3.24c2.69,2.58,2.69,6.78,0,9.36c-0.93,0.89-0.93,2.35,0,3.24c0.93,0.89,2.44,0.89,3.37,0 C93.24,53.55,93.24,46.45,88.69,42.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003070165099324824050000008147607225812415907_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.4982,
    y1: 41.1086,
    x2: 147.6406,
    y2: 79.6923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003070165099324824050000008147607225812415907_)"
    },
    d: "M8.1,67.64c0.93,0.89,2.44,0.89,3.37,0 c0.93-0.89,0.93-2.34,0-3.24c-8.27-7.95-8.27-20.84,0-28.79c0.93-0.89,0.93-2.34,0-3.24c-0.93-0.89-2.44-0.89-3.37,0 C-2.03,42.1-2.03,57.9,8.1,67.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137817120712863264580000015717704608628317368_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.2739,
    y1: 40.0674,
    x2: 147.8648,
    y2: 78.6512
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137817120712863264580000015717704608628317368_)"
    },
    d: "M13.16,62.78c0.93,0.89,2.44,0.89,3.37,0 c0.93-0.89,0.93-2.34,0-3.24c-5.48-5.27-5.48-13.81,0-19.08c0.93-0.89,0.93-2.34,0-3.24c-0.93-0.89-2.44-0.89-3.37,0 C5.82,44.28,5.82,55.72,13.16,62.78z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083803377194800811340000001533567277764540317_",
    gradientUnits: "userSpaceOnUse",
    x1: -31.0501,
    y1: 39.0284,
    x2: 148.0886,
    y2: 77.6122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5CE1E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6773E9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083803377194800811340000001533567277764540317_)"
    },
    d: "M18.2,57.92c0.93,0.89,2.44,0.89,3.37,0 c0.93-0.89,0.93-2.34,0-3.24c-2.69-2.58-2.69-6.78,0-9.36c0.93-0.89,0.93-2.35,0-3.24c-0.93-0.89-2.44-0.89-3.37,0 C13.66,46.45,13.66,53.55,18.2,57.92z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5613e33f86d1a2cd201794b6c6b84da0.svg";
export { ForwardRef as ReactComponent };